var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuestic-data-table table-responsive",
      class: { "data-loading": _vm.loading },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align--center",
          class: _vm.controlsAlignmentClass,
          style: {
            display: _vm.filterSelectShown ? "flex" : "none !important",
          },
        },
        [
          _c("search-bar", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.filterSelectShown,
                expression: "filterSelectShown",
              },
            ],
            attrs: { label: _vm.filterSelectLabel },
            on: { input: _vm.onFilterSet },
          }),
          _c(
            "div",
            { staticClass: "datatable-controls flex" },
            [
              _c(
                "div",
                { staticClass: "form-group" },
                [_vm._t("additionalTableControl")],
                2
              ),
              _c("items-per-page", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.perPageSelectorShown,
                    expression: "perPageSelectorShown",
                  },
                ],
                attrs: {
                  options: _vm.itemsPerPage,
                  label: _vm.itemsPerPageLabel,
                  defaultPerPage: _vm.defaultPerPageComputed,
                },
                on: { "items-per-page": _vm.onItemsPerPage },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "data-table-loading",
        },
        [
          _vm._t("loading", function () {
            return [
              _c("spring-spinner", {
                attrs: {
                  slot: "loading",
                  "animation-duration": 2500,
                  size: 70,
                  color: "#4ae387",
                },
                slot: "loading",
              }),
            ]
          }),
        ],
        2
      ),
      _c("vuetable", {
        ref: "vuetable",
        attrs: {
          apiUrl: _vm.apiUrl,
          apiMode: _vm.apiMode,
          httpFetch: _vm.httpFetch,
          httpOptions: _vm.httpOptions,
          fields: _vm.tableFields,
          dataManager: _vm.dataManager,
          css: _vm.css.table,
          dataPath: "list",
          data: _vm.data,
          paginationPath: _vm.paginationPathComputed,
          appendParams: _vm.moreParams,
          perPage: _vm.perPage,
          queryParams: _vm.queryParams,
          noDataTemplate: _vm.noDataTemplate,
        },
        on: {
          "vuetable:pagination-data": _vm.onPaginationData,
          "vuetable:loading": _vm.onLoading,
          "vuetable:loaded": _vm.onLoaded,
        },
      }),
      _vm.data.total > 0
        ? _c(
            "div",
            { staticClass: "flex-center" },
            [
              _c("vuetable-pagination", {
                ref: "pagination",
                attrs: {
                  "tb-pagination": _vm.data,
                  css: _vm.css.pagination,
                  onEachSide: _vm.onEachSide,
                },
                on: { "vuetable-pagination:change-page": _vm.onChangePage },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }